import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

// Toggles a grant's favorite flag via a turbo_stream PATCH so Turbo can morph
// the favorite-star element in place. Replacing outerHTML directly (the prior
// approach) bypassed Turbo, broke focus restoration, and silently failed on
// network errors.
export default class extends Controller {
  static values = { url: String }
  static classes = ["error"]

  async toggle(event) {
    if (this._inflight) return
    this._inflight = true

    const button = event?.currentTarget
    button?.setAttribute("aria-busy", "true")

    try {
      const token = document.querySelector('meta[name="csrf-token"]')?.content
      const response = await fetch(this.urlValue, {
        method: "PATCH",
        headers: {
          "X-CSRF-Token": token,
          "Accept": "text/vnd.turbo-stream.html"
        }
      })

      if (!response.ok) {
        this._showError(button, `Favorite toggle failed (HTTP ${response.status})`)
        return
      }

      const stream = await response.text()
      Turbo.renderStreamMessage(stream)
    } catch (err) {
      this._showError(button, err?.message || "Network error toggling favorite")
    } finally {
      this._inflight = false
      button?.removeAttribute("aria-busy")
    }
  }

  _showError(button, message) {
    if (!button) return
    button.setAttribute("title", message)
    button.classList.add("text-danger")
  }
}
